import { language } from "../../language";
import { DE } from "./de";
import { EN } from "./en";
export function componentTranslations() {
    switch (language()) {
        case "de":
            return DE;
        default:
            return EN;
    }
}
//# sourceMappingURL=index.js.map